import { formatCodeName } from '@atlas-frontend/sdk';

export interface CommentDescriptionLabelSource {
  sampleDataObjectDescriptionCode?: string | null;
  sampleDataObjectDescriptionName?: string | null;
}

export const getCommentDescriptionLabel = (
  comment: CommentDescriptionLabelSource,
) =>
  formatCodeName({
    code: comment.sampleDataObjectDescriptionCode ?? undefined,
    name: comment.sampleDataObjectDescriptionName ?? undefined,
  });
